<template>
  <v-card
    :class="['fill-height text-left d-flex flex-column', { dsfr: !link.canAnswer }]"
    outlined
    :href="link.canAnswer ? answerUrl : null"
  >
    <v-card-title>
      {{ cardTitle }}
    </v-card-title>

    <v-card-subtitle>
      {{ link.canteen.name }}
      <!-- La recommandation dont l'activite est tiree : deux campagnes peuvent partager le meme
           questionnaire, le titre seul ne suffit alors pas a dire a laquelle on repond. -->
      <span v-if="experienceMention" class="d-block experience-mention">{{ experienceMention }}</span>
    </v-card-subtitle>

    <v-card-text>
      {{ link.survey.description }}
    </v-card-text>

    <v-spacer></v-spacer>
    <v-card-actions class="px-4 py-4">
      <v-spacer></v-spacer>
      <template v-if="link.canAnswer">
        <span class="text-caption mr-2">Répondre</span>
        <v-icon color="primary" aria-hidden="true">$arrow-right-line</v-icon>
      </template>
      <span v-else class="text-caption">Déjà répondu</span>
    </v-card-actions>
  </v-card>
</template>

<script>
import { surveyAnswerUrl } from "@/utils"
export default {
  name: "SurveyLinkCard",
  props: {
    link: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // L'activite nomme la carte quand elle en porte une : c'est elle que le convive a acceptee.
    // A defaut, on retombe sur la recommandation puis sur le questionnaire.
    cardTitle() {
      return this.link.actionTitle || this.link.title || this.link.survey.name
    },
    // Mentionnee seulement si elle ajoute quelque chose au titre deja affiche.
    experienceMention() {
      if (!this.link.title || this.link.title === this.cardTitle) return ""
      return this.link.title
    },
    answerUrl() {
      return surveyAnswerUrl(this.link.survey, {
        canteenId: this.link.canteen && this.link.canteen.id,
        experienceId: this.link.eatingExperienceId,
        actionId: this.link.actionId,
      })
    },
  },
}
</script>

<style scoped>
.experience-mention {
  font-style: italic;
}
</style>
